import React from 'react';
import {Link} from 'react-router-dom';
import AurPageHeader from '../../../common/aur-page-header/AurPageHeader';

const PageHeader: React.FC = () => {
  const clickLinkHandler = () => {
    alert('Link clicked');
  };

  return (
    <div style={{marginBottom: '64px'}}>
      <h1>Page Header</h1>
      <Link to="/demo">Return</Link>
      <hr />
      <div style={{marginBottom: '32px'}}>
        <AurPageHeader
          heading="User Profile"
          linkLabel="Back"
          onLinkCLick={clickLinkHandler}
        />
      </div>
    </div>
  );
};

export default PageHeader;
